export const CustomerRoles = {
  Basic: 'Basic Access',
  Intermediate: 'Intermediate Access',
  Premium: 'Premium Access'
} as const;
